<nav>
  <ul>
    <li *ngFor="let item of items; let index = index">
      <svg
        width="76px"
        height="11px"
        viewBox="0 0 76 11"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        class="topSvg"
        *ngIf="isSelected(item.storeKey())"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="tab-corner"
            transform="translate(38.000000, 5.500000) scale(1, -1) translate(-38.000000, -5.500000) "
            fill-rule="nonzero"
          >
            <path
              d="M0,0 L0,4 L66,4 C70.5,4 74.3,6.4 75.5,10.5 L76,10.5 L76,0 L0,0 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </svg>

      <div
        (click)="onTabClick(item)"
        [ngClass]="{ active: isSelected(item.storeKey()) }"
      >
        <i [inlineSVG]="getIcon(item.icon())"></i>
        <span>{{ item.label(true) }}</span>
      </div>

      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="76"
        height="10.5"
        viewBox="0 0 76 10.5"
        *ngIf="isSelected(item.storeKey())"
      >
        <path d="M0,0V4H66c4.5,0,8.3,2.4,9.5,6.5H76V0Z" />
      </svg>
    </li>
  </ul>
</nav>
